<template>
  <div>
    {{type==='second'?second:minSec}}<slot></slot>
  </div>
</template>

<script>
  export default {
    // time：毫秒
    props: {
      time: {
        default: 30 * 1000
      },
      type: {
        default: 'second'
      }
    },
    data () {
      return {
        mTime: this.type === 'second' ? this.time : 30 * 60 * 1000 - this.time
      }
    },
    created () {
      this.start()
    },
    methods: {
      start () {
        if (this.mTime <= 0) {
          this.$emit('stop')
          return
        }
        setTimeout(() => {
          this.mTime = this.mTime - 1000
          this.start()
        }, 1000)
      }
    },
    computed: {
      minSec () {
        let temp = Math.floor(this.mTime / 1000)
        let m = Math.floor(temp / 60) + ':'
        let s = Math.floor(temp % 60)
        s = s < 10 ? '0' + s : s + ''
        return m + s
      },
      second () {
        return Math.floor(this.mTime / 1000)
      }
    }
  }
</script>

<style scoped>
</style>
